export class CalculatorConstants {

}

export class VehicleConstants {

  //Vehicle Weight Level
  public static WEIGHT_LEVEL_LOW = 1;
  public static WEIGHT_LEVEL_AVG = 2;
  public static WEIGHT_LEVEL_HIGH = 3;

  public static PERCENT_ELECTRIC_TYPE = 0.1; // 10%
  public static PERCENT_PLUGIN_TYPE = 0.4; // 40%
  public static PERCENT_VAT = 0.18; // 17%
  public static PERCENT_VAT18 = 0.18; // 17%
  public static PERCENT_VAT17 = 0.17; // 17%
  public static PERCENT_CURRENCY = 0.005; // 0.5%

  public static ELECTRIC_TYPE_NAME = 'electric';
  public static PLUGIN_TYPE_NAME = 'plug-in';
  public static HYBRID_TYPE_NAME = 'hybrid';

}

export class ShipmentConstants {

  public static PERCENT_CURRENCY = 0.045; // 4.5%

}
